<div class="topbar">
  <h2>Receipts Of Today</h2>
  <section class="right-side">
    <button techIconRoundButton (click)="callback()">
      <tech-icon>unfold_more</tech-icon>
    </button>
    <buton techIconRoundButton techButtonColor="danger" (click)="close()">
      <tech-icon>close</tech-icon>
    </buton>
  </section>
</div>
@if (loading$ | async) {
  <div class="loading-spinner">
    <span>Loading permanent storage...</span>
    <tech-loader techLoadingSize="lg"></tech-loader>
  </div>
} @else {
  <div mat-dialog-content class="table-wrapper">
    <table
      techTable
      [dataSource]="dataSource"
      *techDisplayColumnDef="let columns of displayColumns"
    >
      @for (col of displayColumns; track col) {
        <ng-container techColumnDef="{{ col }}">
          <th tech-header-cell *techHeaderCellDef>
            {{ col.toUpperCase() }}
          </th>
          <td tech-cell *techCellDef="let element">
            {{ element[col] }}
          </td>
        </ng-container>
      }
      <tr tech-header-row *techHeaderRowDef="columns"></tr>
      <tr
        tech-row
        *techRowDef="let row; columns: columns; let odd = even"
        [techDetailRowDef]="row"
        [techRowColor]="'default'"
        [templateRef]="expanded"
        [odd]="odd"
      ></tr>
      <ng-template #expanded let-data>
        <tr
          [techDetailsRow]="data.odd"
          [columns]="columns"
          [techRowColor]="data.color"
        ></tr>
      </ng-template>
    </table>
  </div>
}
